module.exports = __webpack_public_path__ + "img/socialmedia.5df8ac1c.png";